import { ECurves } from './interfaces';
import {
	mapOwnership,
	mapRoadSystem,
	mapRoadSeal,
	lookupCell,
	lookupAttrCell
} from '#lib/common/mappings.js';
import type { AttributesLayoutHelper } from '#lib/components/Attributes.types.js';
import type { FeatureRow, TableColumnDef } from '#lib/components/table/tanstackFeatures.js';

// Cross-app FHWA mappings live in `#lib/common/mappings.ts` — imported above.

// --- Attributes panel layout ---

const attributesMireCurves: AttributesLayoutHelper = {
	title: { accessorKey: 'road_name' },
	subheaders: [[{ accessorKey: 'county' }]],
	body: [
		{ accessorKey: 'ownership', header: () => 'Ownership', cell: lookupAttrCell(mapOwnership) },
		{
			accessorKey: 'speed_limit',
			header: () => 'Speed limit',
			cell: (info) => `${info} mph`
		}
	],
	table: [
		{
			accessorKey: 'road_seal',
			header: () => 'Surface',
			cell: lookupAttrCell(mapRoadSeal)
		},
		{
			accessorKey: 'road_system',
			header: () => 'Functional System',
			cell: lookupAttrCell(mapRoadSystem)
		},
		{ accessorKey: 'mire_77_terrain_category', header: () => '77: Terrain category' },
		{ accessorKey: 'mire_193_unique_curve_id', header: () => '193: Curve identifier' },
		{ accessorKey: 'mire_195_curve_radius_avg', header: () => '195: Curve radius (avg.)' },
		{ accessorKey: 'mire_195_curve_radius_min', header: () => '195: Curve radius (min.)' },
		{ accessorKey: 'mire_196_curve_length', header: () => '196: Curve length' },
		{ accessorKey: 'mire_199_curve_angle', header: () => '199: Curve angle' },
		{ accessorKey: 'mire_200_curve_direction', header: () => '200: Curve direction' }
	]
};

export const attributesColumns: Record<string, AttributesLayoutHelper> = {
	[ECurves.Curves]: attributesMireCurves
};

// --- Table column definitions (per Table tab) ---

type TableTabId = 'Curves';

export const tableColumnsByTab: Record<TableTabId, TableColumnDef<FeatureRow>[]> = {
	Curves: [
		{ accessorKey: 'road_name', header: 'Road name', meta: { bold: true } },
		{ accessorKey: 'county', header: 'Location' },
		{ accessorKey: 'ownership', header: 'Ownership', cell: lookupCell(mapOwnership) },
		{ accessorKey: 'speed_limit', header: 'Speed limit (mph)' },
		{
			accessorKey: 'road_system',
			header: 'Functional System',
			cell: lookupCell(mapRoadSystem)
		},
		{ accessorKey: 'mire_77_terrain_category', header: '77: Terrain category' },
		{ accessorKey: 'mire_193_unique_curve_id', header: '193: Curve identifier' },
		{ accessorKey: 'mire_195_curve_radius_avg', header: '195: Curve radius (avg.)' },
		{ accessorKey: 'mire_195_curve_radius_min', header: '195: Curve radius (min.)' },
		{ accessorKey: 'mire_196_curve_length', header: '196: Curve length' },
		{ accessorKey: 'mire_199_curve_angle', header: '199: Curve angle' },
		{ accessorKey: 'mire_200_curve_direction', header: '200: Curve direction' }
	]
};
